import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { RouterState } from '@ngrx/router-store';

import { RouterHistoryState, RouterHistoryService } from '@c4/core';

import { ProgrammingUtilsService as Utils } from './../../common/services/utils.service';
import { SharedProgrammingService, CommonProgrammingContext } from '../../common/services/shared-programming.service';
import { BaseRoutingComponent } from '../../common/base-routing/base-routing.component';
import { HappeningTodayPipe } from '../../common/pipes/happening-today.pipe';
import { Event } from '../../common/interfaces/event.interface';
import { ScheduleProgrammingService, ScheduleQuickstartContext } from '../../quickstarts/quickstart-schedule/services/schedule.service';

@Component({
  selector: 'prg-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.less']
})
export class EditComponent extends BaseRoutingComponent implements OnInit {
  ready: Observable<boolean>;
  expanded: Observable<boolean>;
  paths: Observable<Array<any>>;
  event: Observable<any>;

  private _message: string = '';
  private _showAlertModal: boolean = false;

  constructor(
    protected router: Router,
    protected shared: SharedProgrammingService,
    private schedules: ScheduleProgrammingService,
    protected store: Store<{
      scheduleProgramming: ScheduleQuickstartContext,
      sharedProgramming: CommonProgrammingContext,
      routerHistory: RouterHistoryState
    }>,
    private _routerHistory: RouterHistoryService,
    private route: ActivatedRoute,
    private utils: Utils
  ) {
    super();

    this.expanded = this.shared.eventExpanded;
    this.event = this.store.select(s => s.sharedProgramming.trigger.event);
    this.ready = Observable.combineLatest(
      this.store.select(s => s.sharedProgramming.ready),
      this.store.select(s => s.scheduleProgramming.ready),
      (a, b) => (a && b)
    ).distinctUntilChanged();
  }

  ngOnInit() {
    this.shared.clearError();
    // this.shared.setTitle('Back');
    this.shared.setEditing(true);
    this.shared.setEventExpanded(true);
  }

  ngOnDestroy() {
  }

  private _showConfirmDeleteAllActions = false;
  private _showConfirmDeleteSchedule = false;
  private _showAccessDeniedModal = false;

  private showConfirmDeleteAllActions(state: boolean) {
    this._showConfirmDeleteAllActions = state
  }

  private deleteAllActions() {
    this.showConfirmDeleteAllActions(false);
    this.shared.deleteAllActions();
  }

  private showConfirmDeleteSchedule(state: boolean) {
    let event: Event = Utils.snapshot<Event>(this.event);
    if (!!event) {
      if (!event.hasProtected || (!!event.codeItems && event.codeItems.length === 0)) {
        this._showConfirmDeleteSchedule = state;
      }
      else {
        this._showAccessDeniedModal = true;
      }
    }
  }

  private deleteSchedule() {
    this.showConfirmDeleteSchedule(false);
    let event = Utils.snapshot<Event>(this.event);
    this.schedules.deleteSchedule(event).then(res => {
      // NOTE can't do this in ngOnDestroy because we might be in the middle of an edit flow
      // when this component is destroy, so force exit from edit mode here
      // NOTE assume the user wants to go back to the schedule list
      this.router.navigate(['when-then/start/edit'], { relativeTo: this.moduleRoot });
    }, err => {
      console.error('error deleteing schedule', err);
      this.shared.error(err);
    });
  }


  runTest() {
    this._message = 'The testing of this automation is in progress.';
    this._showAlertModal = true;
    this.shared.triggerEvent().then(res => {
      this._message = 'The testing of this automation is complete. Please verify the expected outcome.';
    }, err => {
      this._message = 'An error occurred while testing this automation.  Please double check the automation and try again.  Contact your Control4 dealer if you continue to see this message.';
    });;
  }

  close() {

    let routerHistory = Utils.snapshot(this.store.select(s => s.routerHistory));
    let mostRecent: RouterState;

    if (routerHistory.connected) {
      mostRecent = routerHistory.history.find(rs => {
        return rs.path.indexOf('when-then/start/edit') > -1 || rs.path.indexOf('when-then/start/create') > -1;
      });
    }

    if (!!mostRecent) {
      this.router.navigate([mostRecent.path]);
    } else {
      this.router.navigate(['when-then/start/edit'], { relativeTo: this.moduleRoot });
    }
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/edit/edit.component.ts